<app-header-cartographie screenTitle="Scénarisation" />
<app-breadcrumb-scenarisation></app-breadcrumb-scenarisation>
<div class="bg-background py-lg gap-md h-[calc(100%-105px)] w-full overflow-y-auto px-11">
  <router-outlet></router-outlet>
</div>
